import { NEW_DELIVERY_CHARGE, warehouseId } from "../../constants";
import { makeApiCall } from "../makeApiCall";
import {
  AdminService_URL,
  CustomerService_NEW_URL,
  DoctorService_NEW_URL,
  DoctorService_URL,
  OrderManagementService_NEW_URL,
  OrderManagementService_URL,
  ThirdPartyService_NEW_URL,
  ThirdPartyService_URL,
  WarehouseMumbaiService_URL,
} from "../Url";

export const newCheckerActions = {
  FETCH_SCANNED_CHECKER_ORDER_DATA_SUCCESS:
    "FETCH_SCANNED_CHECKER_ORDER_DATA_SUCCESS",
  FETCH_SCANNED_CHECKER_ORDER_DATA_FAILURE:
    "FETCH_SCANNED_CHECKER_ORDER_DATA_FAILURE",
  SAVE_MISSING_MEDS_SUCCESS: "SAVE_MISSING_MEDS_SUCCESS",
  SAVE_MISSING_MEDS_FAILURE: "SAVE_MISSING_MEDS_FAILURE",
  CLEAR_CHECKER_ORDER_DATA: "CLEAR_CHECKER_ORDER_DATA",
  EDIT_MRP_SUCCESS: "EDIT_MRP_SUCCESS",
  EDIT_MRP_ERROR: "EDIT_MRP_ERROR",
  SET_QTY_SUCCESS: "SET_QTY_SUCCESS",
  SET_QTY_FAILURE: "SET_QTY_FAILURE",
  CHECK_INVOICE_EXISTS_SUCCESS: "CHECK_INVOICE_EXISTS_SUCCESS",
  CHECK_INVOICE_EXISTS_FAILURE: "CHECK_INVOICE_EXISTS_FAILURE",
  CREATE_INVOICE_SUCCESS: "CREATE_INVOICE_SUCCESS",
  CREATE_INVOICE_ERROR: "CREATE_INVOICE_ERROR",
  DELETE_INVOICE_SUCCESS: "DELETE_INVOICE_SUCCESS",
  DELETE_INVOICE_FAILURE: "DELETE_INVOICE_FAILURE",
  GET_MED_DETAILS_SUCCESS: "GET_MED_DETAILS_SUCCESS",
  GET_MED_DETAILS_FAILURE: "GET_MED_DETAILS_FAILURE",
  ADD_OR_UPDATE_DESK_NUMBER_SUCCESS: "ADD_OR_UPDATE_DESK_NUMBER_SUCCESS",
  ADD_OR_UPDATE_DESK_NUMBER_FAILURE: "ADD_OR_UPDATE_DESK_NUMBER_FAILURE",
  GENERATE_INVOICE_SUCCESS: "GENERATE_INVOICE_SUCCESS",
  GENERATE_INVOICE_ERROR: "GENERATE_INVOICE_ERROR",
  FETCH_DESK_DETAILS_SUCCESS: "FETCH_DESK_DETAILS_SUCCESS",
  FETCH_DESK_DETAILS_FAILURE: "FETCH_DESK_DETAILS_FAILURE",
  ENABLE_DISABLE_MEDS_SUCCESS: "ENABLE_DISABLE_MEDS_SUCCESS",
  ENABLE_DISABLE_MEDS_FAILURE: "ENABLE_DISABLE_MEDS_FAILURE",
  GET_ORDER_ITEM_BATCHES_FROM_NETSUITE_SUCCESS:
    "GET_ORDER_ITEM_BATCHES_FROM_NETSUITE_SUCCESS",
  GET_ORDER_ITEM_BATCHES_FROM_NETSUITE_FAILURE:
    "GET_ORDER_ITEM_BATCHES_FROM_NETSUITE_FAILURE",
  FETCH_FROM_ELASTIC_SEARCH_SUCCESS: "FETCH_FROM_ELASTIC_SEARCH_SUCCESS",
  FETCH_FROM_ELASTIC_SEARCH_FAILURE: "FETCH_FROM_ELASTIC_SEARCH_FAILURE",
  ADD_MEDICINE_SUCCESS: "ADD_MEDICINE_SUCCESS",
  ADD_MEDICINE_FAILURE: "ADD_MEDICINE_FAILURE",
  GET_ITEM_AVAILABLE_STOCK_SUCCESS: "GET_ITEM_AVAILABLE_STOCK_SUCCESS",
  GET_ITEM_AVAILABLE_STOCK_FAILURE: "GET_ITEM_AVAILABLE_STOCK_FAILURE",
  FETCH_ORDER_SUMMARY_DATA_SUCCESS: "FETCH_ORDER_SUMMARY_DATA_SUCCESS",
  FETCH_ORDER_SUMMARY_DATA_FAILURE: "FETCH_ORDER_SUMMARY_DATA_FAILURE",
  CHECK_URL_FAILURE: "CHECK_URL_FAILURE",
  CHECK_URL_SUCCESS: "CHECK_URL_SUCCESS",
};

// getOrderItembatchesFromNetsuit

////////////////////////////////////////////////
//? To get order data for checker after scanning
////////////////////////////////////////////////

export function getScannedCheckerOrderDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.FETCH_SCANNED_CHECKER_ORDER_DATA_SUCCESS,
      payload: props,
    });
  };
}

export function getScannedCheckerOrderDetailsError(error) {
  return {
    type: newCheckerActions.FETCH_SCANNED_CHECKER_ORDER_DATA_FAILURE,
    payload: error,
  };
}

export function getScannedCheckerOrderDetailsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/getOrderDetailForCheckerPwa?orderId=${
    props.orderId
  }&warehouseId=${
    props.warehouseId ? props.warehouseId : 0
  }&isNewFlow=true&fetchOrderStats=${
    props.fetchOrderStats ? true : false
  }&isOrderAssigned=${props.isOrderAssigned ? true : false}`;
  return makeApiCall(
    getUrl,
    getScannedCheckerOrderDetailsSuccess,
    getScannedCheckerOrderDetailsError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

////////////////////////////////////////////////
//? To save missing med for checker
////////////////////////////////////////////////

export function saveCheckerMissingMedicineSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.SAVE_MISSING_MEDS_SUCCESS,
      payload: props,
    });
  };
}

export function saveCheckerMissingMedicineError(error) {
  return {
    type: newCheckerActions.SAVE_MISSING_MEDS_FAILURE,
    payload: error,
  };
}

export function saveCheckerMissingMedicineDetails(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/saveMissingMedicineDetailsForChecker?lastMed=${
    props.lastMed ? props.lastMed : false
  }`;
  return makeApiCall(
    postUrl,
    saveCheckerMissingMedicineSuccess,
    saveCheckerMissingMedicineError,
    "POST",
    props.missingMedicineDetailsList,
    reqHeader,
    props.history
  );
}

////////////////////////////////////////////////
//? To fetch desk & printer data
////////////////////////////////////////////////

export function getDeskDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.FETCH_DESK_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export function getDeskDetailsFailure(error) {
  return {
    type: newCheckerActions.FETCH_DESK_DETAILS_FAILURE,
    payload: error,
  };
}

export function fetchDeskDetailsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/fetchDeskDetails?warehouseId=${
    props.warehouseId ? props.warehouseId : 0
  }`;
  return makeApiCall(
    getUrl,
    getDeskDetailsSuccess,
    getDeskDetailsFailure,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

//////////////////////////////////////

export function editMrpSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.EDIT_MRP_SUCCESS,
      payload: props,
    });
  };
}

export function editMrpError(error) {
  return {
    type: newCheckerActions.EDIT_MRP_ERROR,
    payload: error,
  };
}

//edit mrp
export function editMrpThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/editMrp?productCode=${props.productCode}&orderId=${props.orderId}&productMrp=${props.productMrp}&${NEW_DELIVERY_CHARGE.DELIVERY_CHARGE_TRUE}`;
  return makeApiCall(
    getUrl,
    editMrpSuccess,
    editMrpError,
    "GET",
    null,
    reqHeader
  );
}

export function changeQtySuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.SET_QTY_SUCCESS,
      payload: props,
    });
  };
}

export function changeQtyError(error) {
  return {
    type: newCheckerActions.SET_QTY_FAILURE,
    payload: error,
  };
}

//change qty
export function changeQtyThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${DoctorService_URL}/setSubQuantity?orderId=${props.orderId}&finalSubsId=${props.finalSubsId}&quantity=${props.quantity}&${NEW_DELIVERY_CHARGE.DELIVERY_CHARGE_TRUE}`;
  return makeApiCall(
    postUrl,
    editMrpSuccess,
    editMrpError,
    "POST",
    null,
    reqHeader
  );
}

export function checkIfInvoiceExistsInZohoSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.CHECK_INVOICE_EXISTS_SUCCESS,
      payload: props,
    });
  };
}

export function checkIfInvoiceExistsInZohoError(error) {
  return {
    type: newCheckerActions.CHECK_INVOICE_EXISTS_FAILURE,
    payload: error,
  };
}

// check if invoice exists in zoho
export function checkIfInvoiceExistsInZohoThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/checkInvoiceExistsInZoho?orderId=${props.orderId}`;
  return makeApiCall(
    getUrl,
    checkIfInvoiceExistsInZohoSuccess,
    checkIfInvoiceExistsInZohoError,
    "GET",
    null,
    reqHeader
  );
}

export function createInvoiceSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.CREATE_INVOICE_SUCCESS,
      payload: props,
    });
  };
}

export function createInvoiceError(error) {
  return {
    type: newCheckerActions.CREATE_INVOICE_ERROR,
    payload: error,
  };
}

export function createInvoiceThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${ThirdPartyService_URL}/createInvoiceInZoho?warehouseId=${props.warehouseId}&isUpdate=false&${NEW_DELIVERY_CHARGE.DELIVERY_CHARGE_TRUE}`;
  return makeApiCall(
    postUrl,
    createInvoiceSuccess,
    createInvoiceError,
    "POST",
    props.orderId,
    reqHeader
  );
}

export function deleteInvoiceSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.DELETE_INVOICE_SUCCESS,
      payload: props,
    });
  };
}

export function deleteInvoiceError(error) {
  return {
    type: newCheckerActions.DELETE_INVOICE_FAILURE,
    payload: error,
  };
}

export function deleteInvoiceThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${ThirdPartyService_URL}/deleteZohoInvoice?orderId=${props.orderId}`;
  return makeApiCall(
    getUrl,
    deleteInvoiceSuccess,
    deleteInvoiceError,
    "GET",
    null,
    reqHeader
  );
}

export function getMedDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.GET_MED_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export function getMedDetailsError(error) {
  return {
    type: newCheckerActions.GET_MED_DETAILS_FAILURE,
    payload: error,
  };
}

// get all med details
export function getMedDetailsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
    transactionId: "a",
  };
  const getUrl = `${DoctorService_NEW_URL}/fetchDoctorSubsDetails?orderId=${
    props.orderId
  }&isPickerRequest=${props.isPickerRequest ? true : false}`;
  return makeApiCall(
    getUrl,
    getMedDetailsSuccess,
    getMedDetailsError,
    "GET",
    null,
    reqHeader
  );
}

export function addOrUpdateDeskNumberSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.ADD_OR_UPDATE_DESK_NUMBER_SUCCESS,
      payload: props,
    });
  };
}

export function addOrUpdateDeskNumberError(error) {
  return {
    type: newCheckerActions.ADD_OR_UPDATE_DESK_NUMBER_FAILURE,
    payload: error,
  };
}

// add or update desk number
export function addOrUpdateDeskNumberThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/addOrUpdateDeskNumberForOrder?orderId=${props.orderId}&deskNumber=${props.deskNumber}`;
  return makeApiCall(
    postUrl,
    addOrUpdateDeskNumberSuccess,
    addOrUpdateDeskNumberError,
    "POST",
    null,
    reqHeader
  );
}

export function generateInvoicePdfSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.GENERATE_INVOICE_SUCCESS,
      payload: props,
    });
  };
}

export function generateInvoicePdfError(error) {
  return {
    type: newCheckerActions.GENERATE_INVOICE_ERROR,
    payload: error,
  };
}

// add or update desk number
export function generateInvoicePdfThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${
    props.newAlgo ? ThirdPartyService_NEW_URL : ThirdPartyService_URL
  }/generateInvoicePDF?isCallFromPkgMgmt=true&warehouseId=${props.warehouseId}`;
  return makeApiCall(
    postUrl,
    generateInvoicePdfSuccess,
    generateInvoicePdfError,
    "POST",
    props.orderIds,
    reqHeader
  );
}

export function enableDisableMedsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.ENABLE_DISABLE_MEDS_SUCCESS,
      payload: props,
    });
  };
}

export function enableDisableMedsError(error) {
  return {
    type: newCheckerActions.ENABLE_DISABLE_MEDS_FAILURE,
    payload: error,
  };
}

// enable disable med (to change the pack size)
export function enableDisableMedsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${DoctorService_NEW_URL}/enableDisableMeds?status=${props.status}&orderId=${props.orderId}&isPackSizeChange=true&${NEW_DELIVERY_CHARGE.DELIVERY_CHARGE_TRUE}`;
  return makeApiCall(
    postUrl,
    enableDisableMedsSuccess,
    enableDisableMedsError,
    "POST",
    props.finalSubsIdSet,
    reqHeader
  );
}

export function getOrderItembatchesFromNetsuitSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.GET_ORDER_ITEM_BATCHES_FROM_NETSUITE_SUCCESS,
      payload: props,
    });
  };
}

export function getOrderItembatchesFromNetsuitError(error) {
  return {
    type: newCheckerActions.GET_ORDER_ITEM_BATCHES_FROM_NETSUITE_FAILURE,
    payload: error,
  };
}

// get all the batches of all meds by order id
export function getOrderItembatchesFromNetsuitThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${WarehouseMumbaiService_URL}/getOrderItembatchesFromNetsuit?orderId=${props.orderId}`;
  return makeApiCall(
    getUrl,
    getOrderItembatchesFromNetsuitSuccess,
    getOrderItembatchesFromNetsuitError,
    "GET",
    null,
    reqHeader
  );
}

export function fetchFromElasticSearchSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.FETCH_FROM_ELASTIC_SEARCH_SUCCESS,
      payload: props,
    });
  };
}

export function fetchFromElasticSearchError(error) {
  return {
    type: newCheckerActions.FETCH_FROM_ELASTIC_SEARCH_FAILURE,
    payload: error,
  };
}

// search meds using elastic
export function fetchFromElasticSearchThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${CustomerService_NEW_URL}/fetchFromElasticSearch?warehouseId=${warehouseId}&searchString=${props.name}&elasticSearchType=SKU_BRAND_SEARCH&isMultiSearch=true`;
  return makeApiCall(
    getUrl,
    fetchFromElasticSearchSuccess,
    fetchFromElasticSearchError,
    "GET",
    null,
    reqHeader
  );
}

export function addMedicineSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.ADD_MEDICINE_SUCCESS,
      payload: props,
    });
  };
}

export function addMedicineError(error) {
  return {
    type: newCheckerActions.ADD_MEDICINE_FAILURE,
    payload: error,
  };
}

// add medicine
export function addMedicineThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${OrderManagementService_NEW_URL}/addMedicine?srcTypeId=${props.srcTypeId}`;
  return makeApiCall(
    postUrl,
    addMedicineSuccess,
    addMedicineError,
    "POST",
    props.medicineDetails,
    reqHeader
  );
}

export function itemAvailableStockSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.GET_ITEM_AVAILABLE_STOCK_SUCCESS,
      payload: props,
    });
  };
}

export function itemAvailableStockError(error) {
  return {
    type: newCheckerActions.GET_ITEM_AVAILABLE_STOCK_FAILURE,
    payload: error,
  };
}

// add medicine
export function itemAvailableStockThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${WarehouseMumbaiService_URL}/itemAvailableStock`;
  return makeApiCall(
    postUrl,
    itemAvailableStockSuccess,
    itemAvailableStockError,
    "POST",
    props.itemAvailableStockDto,
    reqHeader
  );
}

////////////////////////////////////////////////
//? Clear Checker order data
////////////////////////////////////////////////

export function clearCheckerDetails() {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.CLEAR_CHECKER_ORDER_DATA,
      payload: "",
    });
  };
}

// -----------------------------------------------------------------------------
//? ------------------- To get ORDER SUMMARY DATA
// -----------------------------------------------------------------------------

export function getOrderSummaryDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.FETCH_ORDER_SUMMARY_DATA_SUCCESS,
      payload: props,
    });
  };
}

export function getOrderSummaryDetailsError(error) {
  return {
    type: newCheckerActions.FETCH_ORDER_SUMMARY_DATA_FAILURE,
    payload: error,
  };
}

export function getOrderSummaryDetailsThunk(props) {
  const reqHeader = {
    transactionId: "1",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${OrderManagementService_URL}/getOrderSummaryDetails?orderId=${props.orderId}`;
  return makeApiCall(
    getUrl,
    getOrderSummaryDetailsSuccess,
    getOrderSummaryDetailsError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

// --------------- Check URL Status

export function checkUrlSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newCheckerActions.CHECK_URL_SUCCESS,
      payload: props,
    });
  };
}

export function checkUrlError(error) {
  return {
    type: newCheckerActions.CHECK_URL_SUCCESS,
    payload: error,
  };
}

export function checkUrlThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    // Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${props.url}`;
  return makeApiCall(
    getUrl,
    checkUrlSuccess,
    checkUrlError,
    "get",
    null,
    reqHeader
  );
}
